export default "__VITE_ASSET__DdNy2v1M__"